import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProgramEnrollmentData } from '../../program-enrollments-archive/models/program-enrollment.model';
import { BaseHttpService } from '../../shared/services/base-http.service';
import { textEncodeBase64 } from '../../utils/encode';
import { IncentiveProgramErrorResponse } from '../models/incentive-program-error-response.model';
import { IncentiveProgram } from '../models/incentive-program.model';

@Injectable({
  providedIn: 'root'
})
export class IncentiveProgramsArchiveService extends BaseHttpService<IncentiveProgram> {
  constructor(
    private http: HttpClient) {
    super(http);
    this.apiDomain = environment.membershipApiUrl;
    this.endpoint = 'v1/programs';
  }

  getEnrollmentsByIncentiveProgID(id: string): Observable<ProgramEnrollmentData[]> {
    return this.http.get<ProgramEnrollmentData[]>(`${this.apiDomain}/api/${this.endpoint}/${id}/enrollments`);
  }

  deactivate(id: string, comment: string) {
    const deactivateRequest = {
      ReasonToDeactivate: textEncodeBase64(comment)
    };
    return this.http.put(`${this.apiDomain}/api/${this.endpoint}/${id}/deactivate`, deactivateRequest);
  }

  validateReport(): Observable<IncentiveProgramErrorResponse> {
    return this.http.post<IncentiveProgramErrorResponse>(`${this.apiDomain}/api/${this.endpoint}/validatereport`, {});
  }
}
